module.exports = __webpack_public_path__ + "static/img/Danengren.1fc26df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Danengren.jpg
// module id = F3cp
// module chunks = 1